<template>
    <div class="flight">
        <div class="item">
            <div
                v-for="(flight, index) in result.outbound"
                :key="'flightResult' + index"
                class="result"
            >
                <b class="logo">
                    <flightLogo :flightNumber="flight.flightNumber" />
                    <br />
                </b>
                <div class="float">
                    <div>
                        {{ flight.departureAirport }} -
                        {{ flight.arrivalAirport }}<br />
                        <span style="font-size:11px;">
                            V
                            {{
                                moment(flight.departureDate).format(
                                    'DD MMMM YYYY'
                                )
                            }}
                            <b style="color: #000000;font-size:12px">{{
                                moment(flight.departureDate).format('HH:mm')
                            }}</b>
                            - A
                            {{
                                moment(flight.arrivalDate).format(
                                    'DD MMMM YYYY'
                                )
                            }}
                            <b style="color: #000000; font-size:12px;">{{
                                moment(flight.arrivalDate).format('HH:mm')
                            }}</b>
                        </span>
                        <br />
                        <span
                            v-if="parseInt(flight.baggageIndicator) > 0"
                            style="font-size:10px"
                        >
                            <font-awesome-icon
                                icon="suitcase-rolling"
                                style="color: limegreen"
                            ></font-awesome-icon>
                            Inclusief ruimbagage (gewicht:
                            <span v-if="flight.baggageWeight || flight.baggageAllowance">
                                {{ flight.baggageWeight }} {{ flight.baggageAllowance }}
                            </span>
                            <span v-else=""> ? </span>)
                        </span>
                        <span v-else style="font-size:11px">
                            <font-awesome-icon
                                icon="suitcase-rolling"
                            ></font-awesome-icon>
                            Exclusief ruimbagage
                        </span>
                    </div>

                    <span
                        v-for="(stopOver, index) in flight.stopOvers"
                        :key="'flight.stopOver' + index"
                        style="font-size: 11px"
                    >
                        StopOver in:
                        {{ stopOver.Airport.DisplayNameShort }}

                        (Duur: {{ totalWaitingTime(flight.segments) }})<br />
                    </span>

                    <span style="font-size: 11px" v-on:click="toggleShowSchema">
                        <font-awesome-icon icon="minus" v-if="showSchema" />
                        <font-awesome-icon icon="plus" v-else /> Reisinformatie:
                    </span>
                    <div v-if="showSchema">
                        Classe:{{ flight.bookingClass }}, Stoelen:
                        {{ flight.availability }}
                    </div>
                    <ul
                        v-if="flight.segments.length > 1"
                        v-for="(segment, index) in flight.segments"
                        :key="'flight.segment' + index"
                    >
                        <li v-if="showSchema">
                            {{ segment.FlightNumber }}
                            {{ segment.departureAirport.DisplayNameShort }}
                            {{ moment(segment.departureDate).format('ll') }}
                            {{ segment.departureTime }}
                            <br />
                            {{ segment.arrivalAirport.DisplayNameShort }}
                            {{ moment(segment.arrivalDate).format('ll') }}
                            {{ segment.arrivalTime }}
                        </li>
                        <b v-if="segment.hasAirportChanged"
                            >Let op: vliegveldwijziging!</b
                        >
                    </ul>
                    <pre
                        v-if="showSchema"
                        style="height: 200px;overflow-y: scroll"
                    >
                    {{ flight.segments }}
                    </pre>
                </div>
            </div>
            <div v-if="result.outbound && result.outbound.length > 1">
                <p>Kies een heenvlucht</p>
                <select v-model="outboundIndex">
                    <option
                        v-for="(flight, index) in result.outbound"
                        :key="'result.outbound' + index"
                        :value="index"
                        :style="{
                            background: flightArrivesOnTime(flight),
                        }"
                    >
                        V
                        {{ moment(flight.departureDate).format('lll') }}
                        A
                        {{ moment(flight.arrivalDate).format('lll') }}
                    </option>
                </select>
            </div>
        </div>

        <div class="item">
            <div
                v-for="(flight, index) in result.inbound"
                :key="'result.inbound' + index"
                class="result"
            >
                <b class="logo">
                    <flightLogo :flightNumber="flight.flightNumber" />
                    <br />
                </b>
                <div class="float">
                    <div>
                        {{ flight.departureAirport }} -
                        {{ flight.arrivalAirport }}<br />
                        <span style="font-size:11px;"
                            >V
                            {{
                                moment(flight.departureDate).format(
                                    'DD MMMM YYYY'
                                )
                            }}
                            <b style="color: #000000;font-size:12px;">{{
                                moment(flight.departureDate).format('HH:mm')
                            }}</b>
                            - A
                            {{
                                moment(flight.arrivalDate).format(
                                    'DD MMMM YYYY'
                                )
                            }}
                            <b style="color: #000000; font-size:12px">{{
                                moment(flight.arrivalDate).format('HH:mm')
                            }}</b>
                            <br />
                        </span>
                        <span
                            v-if="parseInt(flight.baggageIndicator) > 0"
                            style="font-size:10px"
                        >
                          <div v-if="this.flight.carriercode === 'HV' || this.flight.carriercode === 'TO'">
                          <font-awesome-icon icon="suitcase" />
                          Incl. klein handbagage &nbsp;
                          </div>

                          <div v-else="">
                          <font-awesome-icon icon="suitcase" />
                          Incl. handbagage &nbsp;
                          </div>

                            <font-awesome-icon
                                icon="suitcase-rolling"
                                style="color: limegreen"
                            ></font-awesome-icon>
                            Inclusief ruimbagage (gewicht:
                            <span v-if="flight.baggageWeight || flight.baggageAllowance">
                                {{ flight.baggageWeight }} {{ flight.baggageAllowance }}
                            </span>
                            <span v-else=""> ? </span>)
                        </span>
                        <span v-else style="font-size:10px">
                            <font-awesome-icon
                                icon="suitcase-rolling"
                            ></font-awesome-icon>
                            Exclusief ruimbagage
                        </span>
                    </div>

                    <span
                        v-for="(stopOver, index) in flight.stopOvers"
                        :key="'flight.stopOver' + index"
                        style="font-size: 11px"
                    >
                        StopOver in:
                        {{ stopOver.Airport.DisplayNameShort }}

                        (Duur: {{ totalWaitingTime(flight.segments) }})<br />
                    </span>

                    <span style="font-size: 11px" v-on:click="toggleShowSchema">
                        <font-awesome-icon icon="minus" v-if="showSchema" />
                        <font-awesome-icon icon="plus" v-else /> Reisinformatie:
                    </span>

                    <div v-if="showSchema">
                        Classe:{{ flight.bookingClass }}, Stoelen:
                        {{ flight.availability }}
                    </div>
                    <ul
                        v-if="flight.segments.length > 1"
                        v-for="(segment, index) in flight.segments"
                        :key="'flight.segment' + index"
                    >
                        <li v-if="showSchema">
                            {{ segment.FlightNumber }}
                            {{ segment.departureAirport.DisplayNameShort }}
                            {{ moment(segment.departureDate).format('ll') }}
                            {{ segment.departureTime }}
                            <br />
                            {{ segment.arrivalAirport.DisplayNameShort }}
                            {{ moment(segment.arrivalDate).format('ll') }}
                            {{ segment.arrivalTime }}
                        </li>
                        <b v-if="segment.hasAirportChanged"
                            >Let op: vliegveldwijziging!</b
                        >
                    </ul>
                    <pre
                        v-if="showSchema"
                        style="height:200px; overflow-y: scroll"
                    >
                    {{ flight.segments }}
                    </pre>
                </div>
            </div>
            <div v-if="result.inbound && result.inbound.length > 1">
                <p>Kies een terugvlucht</p>
                <select v-model="inboundIndex">
                    <option
                        v-for="(flight, index) in result.inbound"
                        :key="'result.inbound' + index"
                        :value="index"
                        :style="{
                            background: flightDepartsAfterTimeMessage(flight),
                        }"
                    >
                        V
                        {{ moment(flight.departureDate).format('lll') }}
                        - A
                        {{ moment(flight.arrivalDate).format('lll') }}
                    </option>
                </select>
            </div>
        </div>
        <div class="item prijs" v-if="result.priceBreakdown">
            <br />
            <p>
                <b style="font-size: 14px"
                    >&euro; {{ Math.floor(result.totalPrice) }},- </b
                ><br />
                <small>
                    (&euro;
                    {{
                        Math.floor(
                            result.priceBreakdown.TicketPrices[0].TotalPerPax
                        )
                    }}
                    p.p.)
                </small>
              <br>
              {{result.displayFareType}}
            </p>
            <span v-on:click="togglePriceBreakDown" style="font-size: 11px">
                <font-awesome-icon icon="minus" v-if="showPriceBreakdown" />
                <font-awesome-icon icon="plus" v-else /> Specificaties
            </span>
            <span class="font8 margintop10" v-if="showPriceBreakdown"
                >
              Bron: {{ result.fareSourceInfo }}<br>
              {{result.displayFareType}}
            </span
            >
            <table v-if="showPriceBreakdown">
                <tr>
                    <td align="right">Onze prijs:</td>
                    <td>&euro; {{ Math.floor(result.totalPrice) }},-</td>
                </tr>
                <tr>
                    <td align="right">Total:</td>
                    <td>&euro; {{ result.priceBreakdown.Total }}</td>
                </tr>
                <tr>
                    <td align="right">Tickets:</td>
                    <td>&euro; {{ result.priceBreakdown.TotalTicketPrice }}</td>
                </tr>
                <tr>
                    <td align="right">Services:</td>
                    <td>
                        &euro;
                        {{ result.priceBreakdown.TotalAncillaryServicePrice }}
                    </td>
                </tr>
                <tr>
                    <td align="right">Tax:</td>
                    <td>&euro; {{ result.priceBreakdown.TotalTaxPrice }}</td>
                </tr>
                <tr>
                    <td align="right">Surcharge:</td>
                    <td>
                        &euro; {{ result.priceBreakdown.TotalSurchargePrice }}
                    </td>
                </tr>
                <tr>
                    <td align="right">Discount:</td>
                    <td>
                        &euro; {{ result.priceBreakdown.TotalDiscountPrice }}
                    </td>
                </tr>

                <tr
                    v-for="(ticketPrice, index) in result.priceBreakdown
                        .TicketPrices"
                    :key="'ticketprice' + index"
                >
                    <td align="right" valign="top">
                        Breakdown {{ ticketPrice.PaxType }}:
                    </td>
                    <td>
                        {{ ticketPrice.NumberOfPax }} p
                        <br />
                        &euro; {{ ticketPrice.Total }}
                        <br />
                        Total pp: &euro; {{ ticketPrice.TotalPerPax }}
                        <br />
                        <div
                            v-for="(prel, index) in ticketPrice.PriceElements"
                            :key="'ticketPrice.PriceElements' + index"
                        >
                            {{ prel.Description }}:
                            <span v-if="prel.Sign === 'Positive'"></span>
                            <span v-else="">-</span>
                            &euro;
                            {{ prel.Amount }}
                        </div>
                    </td>
                </tr>
            </table>
        </div>
        <div class="item prijs" v-if="isSelectedFlight">
            <button
                style="width: 100px;"
                v-on:click="deselectFlight"
                :class="{ orange: isSelectedFlight }"
            >
                Deselecteren
            </button>
        </div>

        <div class="item prijs" v-else-if="!isSelectedFlight && parseInt(this.$store.state.payload.dossierID) > 1">
            <button
                style="width: 100px;"
                v-on:click="selectFlight"
                :class="{ orange: isSelectedFlight }"
            >
                Selecteren
            </button>
        </div>
      <div class="item prijs">
        <button
            style="width: 100px;"
            v-if="!baggageOptions && !waitingForBaggage"
            v-on:click="getBaggageForFlight"
        >
          Info ophalen
        </button>
        <span v-else-if="waitingForBaggage">
          <p>Aan het laden..</p>
        </span>
        <span v-else>

          <p v-for="baggage in (baggageOptions.BaggageServiceOptions.BaggageServiceOptions)">
            {{ baggage.DisplayName }} <br>
            Gewicht: {{ baggage.Weight }}<br>
            Stuks: {{ baggage.Pieces }}<br>
            Totaal: &euro;  {{ baggage.TotalPrice }}<br>
          </p>

          <div v-if="baggageOptions.FareOptions">
               <div v-for="fareOption in (baggageOptions.FareOptions)" style="border-bottom: 1px solid grey">
                <b>{{ fareOption.ProviderFareCode}}  {{ fareOption.AirtradeFareCode}}</b><br>
            Totaal: &euro;  {{ fareOption.Price.Total }}<br>
                 <div v-for="service in (fareOption.Services)">
                   <p :class="{ green: service.Included, red: !service.Included }" style="margin:0">-  {{ service.DisplayName }} {{ service.ProviderDescription }} </p>
                 </div>
          </div>
          </div>
<pre style="max-height: 100px;">
  {{ baggageOptions.BaggageServiceOptions.Level }}
  {{ baggageOptions.BaggageServiceOptions.BaggageServiceOptions}}

  {{baggageOptions.AncillaryServiceOptions}}
  {{baggageOptions.TicketConditions}}
</pre>

        </span>
        </div>

    </div>

</template>

<script>
import FlightLogo from './FlightLogo.vue'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faPlus } from '@fortawesome/free-solid-svg-icons'
import Passenger from './Passenger'

library.add(faPlus)

export default {
    name: 'FlightFinderResult',
    components: {
      Passenger,
        FlightLogo,
    },
    data: function() {
        return {
            inboundIndex: 0,
            outboundIndex: 0,
            showSchema: false,
            showPriceBreakdown: false,
        }
    },
    props: {
        result: Object,
        index: Number,
        selectedFlight: Object,
        selectedIndex: Number,
        findOutboundArriveDate: String,
        findOutboundArriveTime: String,
        findInboundDepartDate: String,
        findInboundDepartTime: String,
        findCarrier: String,
        findRate: String,
        availableFlightCarriers: Object,
        availableRatesFlights: Object,
        waitingForBaggage: false,
        baggageOptions: String,
    },
    computed: {
        isSelectedFlight: function() {
            return this.index === this.selectedIndex
        },
    },
    methods: {
        flightDepartsAfterTimeMessage(flight) {
            if (!this.flightDepartsAfterTime(flight)) {
                return '#ffb9b0'
            }
            return ''
        },
        flightDepartsAfterTime(flight) {
            if (this.findInboundDepartTime === '') {
                return true
            }

            let departAfter =
                this.findInboundDepartDate + 'T' + this.findInboundDepartTime
            let dpDt = Date.parse(flight.departureDate)
            let dpAfterDt = Date.parse(departAfter)

            return dpDt >= dpAfterDt
        },
        flightArrivesOnTime(flight) {
            if (this.findOutboundArriveTime === '') {
                return true
            }

            let arriveBefore =
                this.findOutboundArriveDate + 'T' + this.findOutboundArriveTime
            let arDt = Date.parse(flight.arrivalDate)
            let arBeforeDt = Date.parse(arriveBefore)

            return arDt <= arBeforeDt
        },
        totalWaitingTime: function(segments) {
            let totalWaitingSeconds = this.totalWaitingSeconds(segments)
            let date = new Date(null)
            date.setSeconds(totalWaitingSeconds)

            return date.toISOString().substr(11, 5)
        },

        totalWaitingSeconds: function(segments) {
            let seconds = 0

            segments.some(function(segment) {
                if (!segment.waitingTime || segment.waitingTime === '0') {
                    return
                }
                let a = segment.waitingTime.split(':') // split it at the colons
                seconds += +a[0] * 60 * 60 + +a[1] * 60
            })
            return seconds
        },
        toggleShowSchema: function() {
            this.showSchema = !this.showSchema
        },
        togglePriceBreakDown: function() {
            this.showPriceBreakdown = !this.showPriceBreakdown
        },
        deselectFlight: function() {
            this.isHidden = true
            this.selectedIndex = null
            this.selectedFlight = null
        },
        selectFlight: function() {
            let inbound = this.result.inbound[this.inboundIndex]
            let outbound = this.result.outbound[this.outboundIndex]
            let totalPrice = this.result.totalPrice
            let resultListIdentifier = this.result.resultListIdentifier
            let Identifier = this.result.Identifier

            let selectFlight = {
                inbound: [inbound],
                outbound: [outbound],
                totalPrice: totalPrice,
              resultListIdentifier: resultListIdentifier,
              Identifier: Identifier,
            }

            this.$emit('selectFlight', {
                result: selectFlight,
                index: this.index,
            })
        },

      getBaggageForFlight: function() {

            let inbound = this.result.inbound[this.inboundIndex]
            let outbound =  this.result.outbound[this.outboundIndex]
            let totalPrice = this.result.totalPrice

            let selectFlight = {
                inbound: {inbound},
                outbound: {outbound},
                totalPrice: totalPrice,
            }
        this.waitingForBaggage = true;
        let self = this

        self.waiting = true
        self.payload = Object
        self.payload.action = 'getBaggageOptions'
        self.payload.airTradeResult = this.result.resultListIdentifier
        self.payload.airTradeGroup = this.result.Identifier
        self.payload.flightOutbound = outbound
        self.payload.flightInbound = inbound

        $.ajax({
          url: '/paginas/boeken2/ajax.php',
          method: 'GET',
          data: self.payload,
          success: function(responseData) {
            self.waiting = false
            if (!self.error) {
              self.waitingForBaggage = false
              self.baggageOptions = responseData
            }

          },
          error: function(error) {
            self.waiting = false
            self.$store.dispatch('saveLog', error)
          },
        })

        },
    },
}
</script>

<style scoped>
.groot-button {
    padding: 10px;
    text-transform: uppercase;
    border: 1px solid gray;
}

.groot-button:hover {
    background: darkorange;
    cursor: pointer;
}
.green {
  color: limegreen;
}
.red {
  color: orangered;
  text-decoration: line-through;
}

.orange {
    background: orange;
    color: white !important;
}

.flight {
    display: flex;
    width: 100%;
    flex-flow: row;
}

.flight .item {
    width: calc(80% / 2 - 20px);
    display: flex;
    padding: 0;
    flex-flow: column;
}

.item .result {
    margin-top: 10px;

    margin-bottom: 10px;
}

.item .result:not(:last-child) {
    border-bottom: 1px dashed black;
}
.prijs {
    max-width: 10%;
}
.prijs button {
    margin-top: 20px;
}
select {
    width: initial;
    padding: 2px;
    height: initial;
    -webkit-appearance: menulist;
    -moz-appearance: menulist;
    margin-bottom: 10px;
}
.redFilter {
    background-color: #ffb9b0;
}
.float {
    float: left;
    max-width: calc(100% - 40px);
    margin-left: 10px;
}
.logo {
    float: left;
}
.logo .flightlogo {
    width: 40px;
    float: left;
    margin-top: 15px;
    background-size: 100%;
}
</style>
